import { escapeRegExp } from 'lodash';

// Define DOUBLE_QUOTES and ESCAPED_PERIODS regex patterns directly if REGEX is undefined
const DOUBLE_QUOTES = /"/g;
const ESCAPED_PERIODS = /\\\./g;

export const escapeSpecialChars = ({
  chars,
  unescapePeriods,
}: {
  chars: string;
  unescapePeriods?: boolean;
}) => {
  let escapedChars = escapeRegExp(chars);
  if (escapedChars.includes('"')) {
    escapedChars = escapedChars?.replace(DOUBLE_QUOTES, '\\"');
  }

  if (unescapePeriods) {
    escapedChars = escapedChars.replace(ESCAPED_PERIODS, '.');
  }

  return escapedChars;
};
